//Service Kodları ve genel typler buraya gelcek

export interface ResponseCodeProps {
  SUCCESS_CODE: number;
  INTERNAL: number;
  ERROR: number;
  CREATED: number;
  DELETED: number;
  SERVER_INVALID: number;
}

export const RESPONSE_CODE = {
  SUCCESS_CODE: 200,
  INTERNAL: 500,
  ERROR: 404,
  CREATED: 201,
  DELETED: 204,
  SERVER_INVALID: 400,
} as ResponseCodeProps;

export interface ModalTypeProps {
  CREATE: string;
  UPDATE: string;
  DELETE: string;
  DETAIL: string;
}

export const MODAL_TYPES = {
  CREATE: "create",
  UPDATE: "update",
  DELETE: "delete",
  DETAIL: "detail",
} as ModalTypeProps;

export interface BuySellTypeProps {
  BUY: string;
  SELL: string;
}

export const BUY_SELL_TYPES = {
  BUY: "buy",
  SELL: "sell",
} as BuySellTypeProps;

export const Permissions = {
  AddAppointment: "add_appointment",
  ViewAppointment: "view_appointment",
  ChangeAppointment: "change_appointment",
  DeleteAppointment: "delete_appointment",
  AddCategory: "add_category",
  ViewCategory: "view_category",
  ChangeCategory: "change_category",
  DeleteCategory: "delete_category",
  AddCompany: "add_company",
  ViewCompany: "view_company",
  ChangeCompany: "change_company",
  DeleteCompany: "delete_company",
  AddContenttype: "add_contenttype",
  ViewContenttype: "view_contenttype",
  ChangeContenttype: "change_contenttype",
  DeleteContenttype: "delete_contenttype",
  AddCost: "add_cost",
  ViewCost: "view_cost",
  ChangeCost: "change_cost",
  DeleteCost: "delete_cost",
  AddCustomer: "add_customer",
  ViewCustomer: "view_customer",
  ChangeCustomer: "change_customer",
  DeleteCustomer: "delete_customer",
  AddCustomerdevice: "add_customerdevice",
  ViewCustomerdevice: "view_customerdevice",
  ChangeCustomerdevice: "change_customerdevice",
  DeleteCustomerdevice: "delete_customerdevice",
  AddDevice: "add_device",
  ViewDevice: "view_device",
  ChangeDevice: "change_device",
  DeleteDevice: "delete_device",
  AddDevicebuysell: "add_devicebuysell",
  ViewDevicebuysell: "view_devicebuysell",
  ChangeDevicebuysell: "change_devicebuysell",
  DeleteDevicebuysell: "delete_devicebuysell",
  AddDevicepart: "add_devicepart",
  ViewDevicepart: "view_devicepart",
  ChangeDevicepart: "change_devicepart",
  DeleteDevicepart: "delete_devicepart",
  AddDevicepartbuysell: "add_devicepartbuysell",
  ViewDevicepartbuysell: "view_devicepartbuysell",
  ChangeDevicepartbuysell: "change_devicepartbuysell",
  DeleteDevicepartbuysell: "delete_devicepartbuysell",
  AddGroup: "add_group",
  ViewGroup: "view_group",
  ChangeGroup: "change_group",
  DeleteGroup: "delete_group",
  AddLog: "add_log",
  ViewLog: "view_log",
  ChangeLog: "change_log",
  DeleteLog: "delete_log",
  AddLogentry: "add_logentry",
  ViewLogentry: "view_logentry",
  ChangeLogentry: "change_logentry",
  DeleteLogentry: "delete_logentry",
  AddMaintenance: "add_maintenance",
  ViewMaintenance: "view_maintenance",
  ChangeMaintenance: "change_maintenance",
  DeleteMaintenance: "delete_maintenance",
  ViewMaintenancematerialoperation: "view_maintenancematerialoperation",
  ChangeMaintenancematerialoperation: "change_maintenancematerialoperation",
  DeleteMaintenancematerialoperation: "delete_maintenancematerialoperation",
  AddPaidorder: "add_paidorder",
  ViewPaidorder: "view_paidorder",
  ChangePaidorder: "change_paidorder",
  DeletePaidorder: "delete_paidorder",
  AddPayment: "add_payment",
  ViewPayment: "view_payment",
  ChangePayment: "change_payment",
  DeletePayment: "delete_payment",
  AddPermission: "add_permission",
  ViewPermission: "view_permission",
  ChangePermission: "change_permission",
  DeletePermission: "delete_permission",
  AddReminder: "add_reminder",
  ViewReminder: "view_reminder",
  ChangeReminder: "change_reminder",
  DeleteReminder: "delete_reminder",
  AddSession: "add_session",
  ViewSession: "view_session",
  ChangeSession: "change_session",
  DeleteSession: "delete_session",
  AddSupplier: "add_supplier",
  ViewSupplier: "view_supplier",
  ChangeSupplier: "change_supplier",
  DeleteSupplier: "delete_supplier",
  AddTodo: "add_todo",
  ViewTodo: "view_todo",
  ChangeTodo: "change_todo",
  DeleteTodo: "delete_todo",
  AddUser: "add_user",
  ViewUser: "view_user",
  ChangeUser: "change_user",
  DeleteUser: "delete_user",
  AddUsercashadvance: "add_usercashadvance",
  ViewUsercashadvance: "view_usercashadvance",
  ChangeUsercashadvance: "change_usercashadvance",
  DeleteUsercashadvance: "delete_usercashadvance",
  AddUserlocation: "add_userlocation",
  ViewUserlocation: "view_userlocation",
  ChangeUserlocation: "change_userlocation",
  DeleteUserlocation: "delete_userlocation",
} as const;

export const permissionObject = {
  add_appointment: false,
  view_appointment: false,
  change_appointment: false,
  delete_appointment: false,
  add_category: false,
  view_category: false,
  change_category: false,
  delete_category: false,
  add_company: false,
  view_company: false,
  change_company: false,
  delete_company: false,
  add_contenttype: false,
  view_contenttype: false,
  change_contenttype: false,
  delete_contenttype: false,
  add_cost: false,
  view_cost: false,
  change_cost: false,
  delete_cost: false,
  add_customer: false,
  view_customer: false,
  change_customer: false,
  delete_customer: false,
  add_customerdevice: false,
  view_customerdevice: false,
  change_customerdevice: false,
  delete_customerdevice: false,
  add_device: false,
  view_device: false,
  change_device: false,
  delete_device: false,
  add_devicebuysell: false,
  view_devicebuysell: false,
  change_devicebuysell: false,
  delete_devicebuysell: false,
  add_devicepart: false,
  view_devicepart: false,
  change_devicepart: false,
  delete_devicepart: false,
  add_devicepartbuysell: false,
  view_devicepartbuysell: false,
  change_devicepartbuysell: false,
  delete_devicepartbuysell: false,
  add_group: false,
  view_group: false,
  change_group: false,
  delete_group: false,
  add_log: false,
  view_log: false,
  change_log: false,
  delete_log: false,
  add_logentry: false,
  view_logentry: false,
  change_logentry: false,
  delete_logentry: false,
  add_maintenance: false,
  view_maintenance: false,
  change_maintenance: false,
  delete_maintenance: false,
  view_maintenancematerialoperation: false,
  change_maintenancematerialoperation: false,
  delete_maintenancematerialoperation: false,
  add_paidorder: false,
  view_paidorder: false,
  change_paidorder: false,
  delete_paidorder: false,
  add_payment: false,
  view_payment: false,
  change_payment: false,
  delete_payment: false,
  add_permission: false,
  view_permission: false,
  change_permission: false,
  delete_permission: false,
  add_reminder: false,
  view_reminder: false,
  change_reminder: false,
  delete_reminder: false,
  add_session: false,
  view_session: false,
  change_session: false,
  delete_session: false,
  add_supplier: false,
  view_supplier: false,
  change_supplier: false,
  delete_supplier: false,
  add_todo: false,
  view_todo: false,
  change_todo: false,
  delete_todo: false,
  add_user: false,
  view_user: false,
  change_user: false,
  delete_user: false,
  add_usercashadvance: false,
  view_usercashadvance: false,
  change_usercashadvance: false,
  delete_usercashadvance: false,
  add_userlocation: false,
  view_userlocation: false,
  change_userlocation: false,
  delete_userlocation: false,
};
